import React from "react";
import { useNavigate } from "react-router-dom";
import "./buysell.css";
import {
  ArrowLeft,
  ArrowRight,
  Map,
  Home,
  ShieldCheck,
  Plus,
  Search,
} from "lucide-react";

function BuySellLand() {
  const navigate = useNavigate();

  return (
    <div className="bs-page">

      {/* =================================================
          TOP BAR
      ================================================= */}

      <div className="bs-topbar">
        <button
          className="bs-back-btn"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={18} />
          <span>Back</span>
        </button>

        <div className="bs-brand">
          <span className="bs-brand-dot" />
          CIVILINK
        </div>
      </div>


      {/* =================================================
          HERO
      ================================================= */}

      <section className="bs-hero">

        <div className="bs-hero-overlay" />

        <div className="bs-hero-content">

          <div className="bs-eyebrow">
            <Map size={15} />
            LAND MARKETPLACE
          </div>

          <h1>
            Your next piece
            <br />
            <span>starts here.</span>
          </h1>

          <p>
            Buy the right land or list your property
            for the right buyer — all in one place.
          </p>

        </div>

      </section>


      {/* =================================================
          MAIN CONTENT
      ================================================= */}

      <main className="bs-main">

        <div className="bs-heading">

          <div>
            <span className="bs-section-label">
              WHAT WOULD YOU LIKE TO DO?
            </span>

            <h2>
              Buy or sell land
            </h2>

            <p>
              Choose an option to continue.
            </p>
          </div>

        </div>


        {/* =================================================
            OPTIONS
        ================================================= */}

        <div className="bs-options">

          {/* =================================================
              SELL
          ================================================= */}

          <button
            className="bs-card bs-sell-card"
            onClick={() => navigate("/sell-land")}
          >

            <div className="bs-card-top">

              <div className="bs-card-icon">
                <Plus size={25} />
              </div>

              <span className="bs-card-arrow">
                <ArrowRight size={19} />
              </span>

            </div>


            <div className="bs-card-content">

              <span className="bs-card-label">
                FOR LAND OWNERS
              </span>

              <h3>
                Sell a Land
              </h3>

              <p>
                List your land on Civilink and
                connect with potential buyers.
              </p>

            </div>


            <div className="bs-card-footer">

              <span>
                Post your property
              </span>

              <ArrowRight size={16} />

            </div>

          </button>


          {/* =================================================
              BUY
          ================================================= */}

          <button
            className="bs-card bs-buy-card"
            onClick={() => navigate("/buy-land")}
          >

            <div className="bs-card-top">

              <div className="bs-card-icon">
                <Search size={25} />
              </div>

              <span className="bs-card-arrow">
                <ArrowRight size={19} />
              </span>

            </div>


            <div className="bs-card-content">

              <span className="bs-card-label">
                FOR LAND BUYERS
              </span>

              <h3>
                Buy a Land
              </h3>

              <p>
                Explore available plots and lands
                based on your location and budget.
              </p>

            </div>


            <div className="bs-card-footer">

              <span>
                Explore available land
              </span>

              <ArrowRight size={16} />

            </div>

          </button>

        </div>


        {/* =================================================
            TRUST / INFORMATION
        ================================================= */}

        <div className="bs-info-strip">

          <div className="bs-info-item">

            <div className="bs-info-icon">
              <Map size={18} />
            </div>

            <div>
              <strong>
                Explore Properties
              </strong>

              <span>
                Discover land listings
              </span>
            </div>

          </div>


          <div className="bs-info-item">

            <div className="bs-info-icon">
              <Home size={18} />
            </div>

            <div>
              <strong>
                Direct Listings
              </strong>

              <span>
                Connect with listing owners
              </span>
            </div>

          </div>


          <div className="bs-info-item">

            <div className="bs-info-icon">
              <ShieldCheck size={18} />
            </div>

            <div>
              <strong>
                Verify Before Buying
              </strong>

              <span>
                Check property details independently
              </span>
            </div>

          </div>

        </div>


        {/* =================================================
            DISCLAIMER
        ================================================= */}

        <div className="bs-disclaimer">

          <ShieldCheck size={18} />

          <p>
            Civilink is a property listing platform.
            Listings are provided by users and do not
            represent a legal verification or guarantee
            by Civilink. Always inspect the property and
            independently verify ownership, approvals
            and documents before making a transaction.
          </p>

        </div>

      </main>

    </div>
  );
}

export default BuySellLand;